import { utilBuildings } from "../../../utils/utilBuildings";
import { selectBuildingsProducingOrFinishedProductionResourceAvailable } from "../selectors/selectBuildingsProducingOrFinishedProductionResourceAvailable";
import { createPathFocusBuildingMaxLevel } from "./createPathFocusBuildingMaxLevel";
export var pathFocusBuildingProductionDoneMaxLevelByResourceId = function (action, state$, deps) {
    return createPathFocusBuildingMaxLevel(function () {
        var state = state$.value;
        var resourceId = action.taskType.resourceId;
        var availableBuildings = selectBuildingsProducingOrFinishedProductionResourceAvailable(state, resourceId);
        return availableBuildings.filter(utilBuildings.hasFinishedProduction);
    })(action, state$, deps);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/path/pathFocusBuildingProductionDoneMaxLevelByResourceId.ts
// module id = 2359
// module chunks = 3